export default __webpack_public_path__ + "static/media/moneybillwave-1.85c5484f.svg";